import Request, { API } from '@/http/index.js'

// 获取订单详情
export async function getOrderDetails (data) {
  const res = await Request.getData(API.order.dataDetails+ `?minimize=${data.orderNo}&sovereignty=${data.pageType}`)
  return res
}
//获取客服电话
export async function getCustomerPhone () {
  const res = await Request.getData(API.customer.CustomerPhone)
  return res
}

// 提交用户反馈
export async function submitComplaint (data) {
  const res = await Request.getData(API.customer.submitComplaint, data)
  return res
}